"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconHeart = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0a.75.75 0 01.743.648l.007.102v4.044a5.221 5.221 0 00-.563.325l-.239.168a5.196 5.196 0 00-.698-.44V.75A.75.75 0 0112 0zm.75 19.069v4.174a.75.75 0 01-1.493.102l-.007-.102V19.12c.48.208 1.033.192 1.5-.05zM5.376 4.327l.084.073.623.623a5.239 5.239 0 00-1.155.966L4.4 5.46a.75.75 0 01.976-1.133zm11.31 11.31l.084.073 2.83 2.83a.75.75 0 01-.976 1.133l-.084-.073-2.83-2.83a.746.746 0 01-.197-.347l.91-.91a.746.746 0 01.263.124zM4.752 12.75H.793a.75.75 0 01-.101-1.493l.101-.007h3.114c.192.533.473 1.041.845 1.5zm18.498-1.5a.75.75 0 01.102 1.493l-.102.007h-4.107l.13-.168.026-.035-.156.203a5.193 5.193 0 00.752-1.262l.006-.015.086-.223h3.263zM7.496 15.538l.966.966a.744.744 0 01-.099.182l-.073.084-2.83 2.83a.75.75 0 01-1.133-.976l.073-.084 2.83-2.83a.746.746 0 01.266-.172zM19.6 4.4a.75.75 0 01.073.976l-.073.084-.584.586a5.24 5.24 0 00-1.14-.982l.664-.664a.75.75 0 011.06 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.887 5.5a4.224 4.224 0 00-2.748 1.23l-.14.139-.138-.139a4.224 4.224 0 10-5.975 5.975l5.583 5.583a.75.75 0 001.061 0l5.583-5.583a4.224 4.224 0 00-2.987-7.212l-.24.006zm.24 1.493a2.724 2.724 0 012.724 2.724l-.007.197a2.723 2.723 0 01-.791 1.73l-5.054 5.053-5.052-5.053A2.724 2.724 0 1110.8 7.79l.67.67a.75.75 0 001.06 0l.67-.67a2.724 2.724 0 011.926-.798z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconHeart, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;